import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-routing",
  "use": "icon-routing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-routing\"><path d=\"M469.333333 426.666667H213.333333L128 341.333333l85.333333-85.333333h256V128l42.666667-42.666667 42.666667 42.666667v42.666667h256l85.333333 85.333333-85.333333 85.333333h-256v85.333334h256l85.333333 85.333333-85.333333 85.333333h-256v256a85.333333 85.333333 0 0 1 85.333333 85.333334H384a85.333333 85.333333 0 0 1 85.333333-85.333334V426.666667z\" fill=\"#8a8a8a\" p-id=\"2511\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol